export default __webpack_public_path__ + "static/media/thumbnail.9d5ad335.webp";